export default __webpack_public_path__ + "static/media/Jobbio_J_Logo_White.f72828a0.svg";